
import {
  defineComponent, onMounted, onUnmounted, ref, watch,
} from 'vue';
import CameraApi from '@/utils/camera';

export default defineComponent({
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    // 控制按钮
    const btns = {
      dir: ['up',
        'RIGHT_UP',
        'right',
        'RIGHT_DOWN',
        'doen',
        'LEFT_DOWN',
        'left',
        'LEFT_UP',],
      focus: [
        { command: 'focusin', label: '焦点前移', icon: 'icon-quanping-fangda-07', },
        { command: 'focusout', label: '焦点后移', icon: 'icon-quanping-fangda-071', },
        { command: 'zoomin', label: '焦距变大', icon: 'icon-fangda1', },
        { command: 'zoomout', label: '焦距变小', icon: 'icon-fangda2', },
      ],
    };

    // 摄像头基本信息
    const cameraInfo = {
      deviceId: '',
      channelId: '',

      // 默认配置
      controSpeed: 30,
    };
    const acitveBtn = ref<string>('');

    // 云台控制
    const handleControl = (command: string) => {
      acitveBtn.value = command;

      const { deviceId, channelId, controSpeed, } = cameraInfo;
      const params = {
        command,
        horizonSpeed: controSpeed,
        verticalSpeed: controSpeed,
        zoomSpeed: controSpeed,
      };

      CameraApi.ptControl(deviceId, channelId, params);
    };

    const init = (val:any) => {
      cameraInfo.deviceId = val.deviceId;
      cameraInfo.channelId = val.channelId;
    };

    watch(() => props.info, (val) => {
      init(val);
    });

    onMounted(() => {
      init(props.info);
    });

    return {
      btns,
      acitveBtn,

      handleControl,
    };
  },
});
